import axios from '@/utils/request.js'
export const getSelectList = (num) => {
  // select
  return axios.get(`/goods/gas/bGlmDicVal/getMessListById/${num}`)
}
export const findCylinerByCode2 = (code) => {
  // select
  return axios.post('https://gangping.botankeji.com/public/gas_glm_cylinder_own_record/findCylinerByCode2', { 
    code: code 
  })
}
